<div class="container hide-scrollbar">
  <br /> 
  <h1>Vertical Vessel</h1>
  <br/>
  <div style="margin-top: 10px;">
    <form [formGroup] ="verticalform" (ngSubmit)="onSubmit()" class="form-horizontal">
        <div class="row form-group" >
          <div class="col-md-4">
            <div class ="row">
              <div class="col-md-12">
              <img src= '/assets/images/VerticalVesselbg.jpg' class="center-block img-thumbnail"/>
              </div>
            </div>
            <div class ="row">
              <div class="col-md-12">
                <br />
                <button typ="button" id="Bid2"  name ="Bnm2"class="btn btn-primary btn-custom no-arrow" (click)="closeDialog()"><span class="icon-chevron-left"></span>
                  &nbsp;Back</button>
              </div>
            </div>
          </div>
          <div class="col-md-5">
           
            <div class ="row">
                <div class="col-md-12">
                  <label  class="control-label form-label-font-size: 10px">Vertical Location of the Flaw, H* 
                    &nbsp;<span *ngIf="this.intUnit === 0" >(inch) <span style="color:red"> *</span></span>
                    <span *ngIf="this.intUnit === 1">(mm) *</span>
                   </label>  
                </div>
            </div>
            <br />
            <br />
            <div class ="row">
              <div class="col-md-12">
                <label  class="control-label">Outside Diameter of Cylindrical or Conical Shell Section, OD 
                  &nbsp;<span *ngIf="this.intUnit === 0">(inch)<span style="color:red"> *</span></span>
                  <span *ngIf="this.intUnit === 1">(mm) *</span>
                </label>  
              </div>
              
            </div>
           
            <div class ="row">
              <div class="col-md-12">
                <br />
                <br />
                <p style="color: {{myColor}};">{{ Result }}</p>
              
                <br />
                <!-- Supplemental Loads question - Only show for GML module when Type A screening fails -->
                <div *ngIf="typaResult === false && isSupplementalLoadsAvailable" style="margin-top: 10px;">
                  <label class="control-label">Are supplement loads available?</label>
                  <div style="margin-top: 5px;">
                    <mat-radio-group [(ngModel)]="supplementalLoadsSelection" [ngModelOptions]="{standalone: true}">
                      <mat-radio-button value="yes" style="margin-right: 15px;">Yes</mat-radio-button>
                      <mat-radio-button value="no">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div *ngIf="supplementalValidationMessage" style="color: red; margin-top: 5px; font-size: 12px;">{{ supplementalValidationMessage }}</div>
                </div>

               </div>
            </div>
            
          </div>
          <div class="col-md-3">
            <div class ="row">
              <div class="col-md-12">
                <input  formControlName ="input1" class=" form-control border-secondary"  type="number" autofocus required /> 
              </div>
            </div>
            <br />
            <div class ="row">
              <div class="col-md-12">
                <input formControlName ="input2" class="form-control border-secondary"  type="number" required/>
              </div>
            </div>
            <div class ="row float-right">
              <div class="col-md-12">
                <br />
                <br />
                <br />
                <br />
                <button class="btn btn-primary btn-custom no-arrow"  id="Bid1" name ="Bnm1" type="submit" (click)="onSubmit()">Calculate&nbsp;<span class="icon-chevron-right"></span></button>  
              </div>
            </div>
            <div class ="row float-right">             
              <div class="col-md-12" >               
                <br />
                <div style="margin-top:330px"></div>
                <button  typ="button"id="Bid3"  name ="Bnm3" class="btn btn-primary btn-custom no-arrow" [disabled]="isDisabled" (click)="BacktoALS()">Next&nbsp;<span class="icon-chevron-right"></span></button>     
              </div>
            </div>
          </div>         
        </div>          
      </form>    
  </div>

</div>
